const key_base="HUALUE_PORTAL_";
const key_userInfo=key_base+"UserInfo";
const key_NewsDetailP=key_base+"NewsDetailP";//新闻详情参数

let data={
	/**
	 * [保存用户信息]
	 * @param {[userInfo]} userInfo  [用户信息]
	 */
	saveUserInfo:function(userInfo){
		window.sessionStorage.setItem(key_userInfo,JSON.stringify(userInfo));
	},
	/**
	 * [得到用户信息]
	 */
	getUserInfo:function(){
		return JSON.parse(window.sessionStorage.getItem(key_userInfo))||{};
	},

	/**
	 * [保存新闻详情参数]
	 * @param {[userInfo]} info
	 */
	saveNewsDetailP:function(info){
		window.localStorage.setItem(key_NewsDetailP,JSON.stringify(info));
	},
	/**
	 * [得到新闻详情参数]
	 */
	getNewsDetailP:function(){
		return JSON.parse(window.localStorage.getItem(key_NewsDetailP))||{};
	},

	/**
	 * 清空当前key_base所有
	 */
	clear:function() {
		let sessionKeys = Object.keys(sessionStorage);
		if(sessionKeys instanceof Array){
			for (var i=0;i<sessionKeys.length;i++) {
				if(sessionKeys[i].indexOf(key_base)!=-1){
					sessionStorage.removeItem(sessionKeys[i]);
				}
			}
		}
		// window.sessionStorage.clear();
	}
}

export default data;